import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import toast from "react-hot-toast";

//Serivce
import ItemService from "../../../../services/customer_appCommonService";
import { useDispatch } from "react-redux";
import { getMaterialList } from "../../../../redux/feature/customer_app/customerSlice";

const DeleteMaterialV5 = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const [getdisable, setDisabled] = useState(false);

  const handleDelete = async () => {
    let obj = {
      materialCode: props.data.materialCode,
    };

    setDisabled(true);

    await ItemService.deleteMaterial(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        toast.success(item?.message || "successfully Deleted", {
          duration: 2000,
          position: "top-right",
        });
        // setErrorMsg("");
        props.onHide();
        let obj = {
          queryName: "getMaterilMasterList",
          page: 1,
          per_page: 10,
        };
        dispatch(getMaterialList(obj));
        // Update response value in Redux Store
        // dispatch(getTeamData(compIdObj));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
        // setErrorMsg("*" + item?.message);
      }
      setDisabled(false);
    });
    toast.dismiss("");
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="md"
      ref={ref}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {/* <i className="bi bi-plus-lg"></i>  */}
          Delte Material
          {/* <p className="subText">
            At supplier_app, every person has a role, each with its own level of
            access.
          </p> */}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        <div className="d-flex justify-content-center align-items-center">
          <p className="p-0 m-0">
            Are you sure you want to delete{" "}
            <span className="fw-bold">{props?.data?.materialCode}</span> ?
          </p>
        </div>
        <div className="space-y-4">
          <Row className="justify-end">
            <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
              <button
                onClick={() => props.onHide()}
                className="btn btn-danger mt-4 justify-center w-full rounded-md"
              >
                Cancel
              </button>
            </Col>
            <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
              <button
                type="button"
                onClick={handleDelete}
                className="btn btn-primary mt-4 w-full justify-center rounded-md"
                disabled={getdisable}
              >
                Delete
              </button>
            </Col>
            <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
              {/* <p className="errorMsg"> {errorMsg} </p> */}
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default DeleteMaterialV5;
